export var WorkflowStatus;
(function (WorkflowStatus) {
    WorkflowStatus["NEEDS_CALL"] = "NEEDS_CALL";
    WorkflowStatus["AWAITING_PATIENT"] = "AWAITING_PATIENT";
    WorkflowStatus["COMPLETED"] = "COMPLETED";
    WorkflowStatus["PROBLEM"] = "PROBLEM";
    WorkflowStatus["INACTIVE"] = "INACTIVE"; // Soft deleted
})(WorkflowStatus || (WorkflowStatus = {}));
export var Priority;
(function (Priority) {
    Priority["LOW"] = "LOW";
    Priority["NORMAL"] = "NORMAL";
    Priority["HIGH"] = "HIGH";
    Priority["URGENT"] = "URGENT";
    // Legacy priorities from seed data
    Priority["SOON"] = "SOON";
    Priority["LATER"] = "LATER";
})(Priority || (Priority = {}));
